<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M9.46938 2.21967L5.21967 6.46938C4.92678 6.76227 4.92678 7.23714 5.21967 7.53004C5.51256 7.82293 5.98744 7.82293 6.28033 7.53004L9.24972 4.56065V17.5992C9.24972 18.0134 9.58551 18.3492 9.99972 18.3492C10.4139 18.3492 10.7497 18.0134 10.7497 17.5992V4.56066L13.7191 7.53004C14.012 7.82293 14.4869 7.82293 14.7798 7.53004C15.0726 7.23714 15.0726 6.76227 14.7798 6.46938L10.53 2.21967C10.5218 2.2114 10.5134 2.20336 10.5048 2.19556C10.2837 1.99378 9.97097 1.94815 9.70841 2.05867C9.62153 2.09524 9.54015 2.14891 9.46938 2.21967Z"
            fill="currentColor"
        />
    </svg>
</template>
